import { Separator } from '@components/ui/separator';
import { Skeleton } from '@components/ui/skeleton';

export function BusinessLineDetailsLoading() {
  return (
    <div className="grid py-4 lg:p-0">
      <div className="border-secondary mb-6 grid gap-y-8 border-b-2 border-dotted pb-2 md:grid-cols-2 lg:gap-4">
        <div className="relative grid grid-rows-[auto_1fr] gap-2 px-4">
          <div className="flex h-fit items-center gap-1">
            <Skeleton className="h-8 w-2/12" />
            <Skeleton className="h-8 w-5/12" />

            <Skeleton className="ml-auto h-8 w-4" />
          </div>
          <div className="grid grid-cols-2 gap-1">
            <Skeleton className="h-3.5 w-6/12" />
            <Skeleton className="h-3.5 w-6/12" />
            <Skeleton className="mb-2 h-4 w-full" />
            <Skeleton className="mb-2 h-4 w-full" />
            <Skeleton className="col-span-2 h-3.5 w-6/12" />
            <Skeleton className="col-span-2 mb-2 h-4 w-full" />
            <Skeleton className="col-span-2 h-3.5 w-6/12" />
            <Skeleton className="col-span-2 mb-2 h-4 w-full" />
            <Skeleton className="h-3.5 w-6/12" />
            <Skeleton className="h-3.5 w-6/12" />
            <Skeleton className="mb-2 h-4 w-full" />
            <Skeleton className="mb-2 h-4 w-full" />
          </div>

          <Separator
            className="invisible absolute top-0 right-0 h-3/4 md:visible"
            orientation="vertical"
            variant="dotted"
          />
        </div>
        <div className="mb-2 grid grid-cols-2 gap-1 pb-8">
          <Skeleton className="h-3.5 w-6/12" />
          <Skeleton className="h-3.5 w-6/12" />
          <Skeleton className="mb-2 h-4 w-full" />
          <Skeleton className="mb-2 h-4 w-full" />
          <Skeleton className="col-span-2 h-3.5 w-6/12" />
          <Skeleton className="col-span-2 mb-2 h-4 w-full" />
          <Skeleton className="col-span-2 h-3.5 w-6/12" />
          <Skeleton className="col-span-2 mb-2 h-4 w-full" />
          <Skeleton className="h-3.5 w-6/12" />
          <Skeleton className="h-3.5 w-6/12" />
          <Skeleton className="mb-2 h-4 w-full" />
          <Skeleton className="mb-2 h-4 w-full" />
        </div>
      </div>
    </div>
  );
}
